export default "__VITE_PUBLIC_ASSET__56515355__"